export interface Address { 
    id?: number|null;
    district?: string;
    city?: string;
    state?: string;
    number: string;
    complement?: string;
    country?: string;
    street?: string;
    cep: string; 
    latitude?: string;
    longitude?:string;   
}

export interface AddressAPIResponse {

    use: string,
    type: string,
    line: string[],
    postalCode : string,
    country?: string,
    state?: string,
    city?: string
  
}

export interface addressI { 
    id?: number|null;
    district?: string;
    city?: string;
    state?: string;
    number?: string;
    complement?: string;
    country?: string;
    street?: string;
    cep: string | number; 
    latitude?: string;
    longitude?:string;   
}

export const addressInitialState: Address = {
    district: '',
    city: '',
    state: '',
    number: '',
    complement: '',
    country: '',
    street: '',
    cep: '',
    latitude: '',
    longitude: ''
}
